<div class="warp-data-question">
  <img class="imgType" src="/assets/images/types/{{questionData?.question?.type?.image}}" />

  <div class="warp-right">
    <div class="data-question">{{ questionData?.question | questionTitle }}</div>

    <!-- comments: רק כשאין פילטר משתמש -->
    <div class="comments" *ngIf="!hasUserFilter">
      <p>{{ questionData?.comments }}</p>
      <p translate>data.comments</p>
    </div>

    <div *ngIf="showComparison$()" class="warp-tag-compare">
      <div><p class="tag" translate>data.current</p></div>
      <div><p class="tag" translate>data.previous</p></div>
    </div>

    <div class="warp-tow-diagrams" *ngFor="let optionData of options; let i = index">
      <ng-container *ngIf="shouldShowOption(optionData, i)">
        <!-- CURRENT -->
        <div class="warp-diagram" [ngClass]="{'showCompare': showComparison$()}">
          <que-diagram
            class="diagram"
            [filterRecipients]="recipientIdToFilter$()"
            [percentage]="optionData.percent"
            [value]="optionData.value"
            [wasChange]="optionData.wasChange">
          </que-diagram>

          <!-- hover: רק כשאין פילטר משתמש -->
          <div class="hover" *ngIf="!hasUserFilter">
            <div class="warp-contact">
              <ng-container *ngFor="let recipient of optionData.recipients; let j = index">
                <div class="recip" *ngIf="(optionData.recipients?.length ?? 0) < 5 || j < 3">
                  <que-contact-circle [user]="recipient?.user"></que-contact-circle>
                </div>
              </ng-container>

              <div *ngIf="(optionData.recipients?.length ?? 0) >= 5" class="contact-plusex">
                <p>+</p>
                <p>{{ (optionData.recipients?.length ?? 0) - 3 }}</p>
              </div>
            </div>

            <div class="warp-tooltip">
              <que-contact-tooltip
                class="tooltip"
                [title]="'dataUsers'"
                [color]="'#B7C7FC'"
                [recipients]="optionData.recipients">
              </que-contact-tooltip>
            </div>
          </div>
        </div>

        <!-- PREVIOUS -->
        <div *ngIf="showComparison$() && optionData.recipientsSource != null" class="warp-diagram showCompare">
          <que-diagram
            class="diagram"
            [filterRecipients]="recipientIdToFilter$()"
            [percentage]="optionData.percentSource"
            [value]="optionData.value">
          </que-diagram>

          <!-- hover: רק כשאין פילטר משתמש -->
          <div class="hover" *ngIf="!hasUserFilter">
            <div class="warp-with-plus">
              <div class="warp-contact">
                <div class="recip" *ngFor="let recipient of optionData.recipientsSource; let j = index">
                  <que-contact-circle
                    *ngIf="(optionData.recipientsSource?.length ?? 0) < 5 || j < 3"
                    [user]="recipient?.user">
                  </que-contact-circle>
                </div>
              </div>

              <div *ngIf="(optionData.recipientsSource?.length ?? 0) >= 5" class="contact-pluse">
                <p>+</p>
                <p>{{ (optionData.recipientsSource?.length ?? 0) - 3 }}</p>
              </div>
            </div>

            <div class="warp-tooltip">
              <que-contact-tooltip
                class="tooltip"
                [title]="'dataUsers'"
                [color]="'#B7C7FC'"
                [recipients]="optionData.recipientsSource">
              </que-contact-tooltip>
            </div>
          </div>
        </div>

      </ng-container>
    </div>
  </div>
</div>

<!-- showAll/hide: רק כשאין פילטר משתמש -->
<div class="warp-button-data" *ngIf="!hasUserFilter && (questionData?.options?.length ?? 0) > 5">
  <div *ngIf="!showAll" (click)="showHide()" class="show-button pointer" translate>data.summary.showAll</div>
  <div *ngIf="showAll" (click)="showHide()" class="hide-button pointer" translate>data.summary.hide</div>
</div>
